<template>
  <section   class="flex" >

      <header  class="container-1">
          <!-- <h3 class="abhyaas">OUR PROGRAMS > Bean Yoga</h3> -->
          <h1>Learn to teach <br> Kids Yoga</h1>
      
      <img src="../../assets/underline.png" alt="">


      <h4>Learn the skills that go into becoming a <br> yoga teacher for kids at your own pace. <br> Our yoga teacher training course is 25 <br> hours of invaluable material from lesson <br> plans to poses and scripts. It will give you <br> the technical proficiency you need to <br> become a kids’ yoga expert. 
<br> <br>  Get on the fast-track to becoming a kids’ <br> yoga teacher on this edu-venture!</h4>



      </header>

<img class="LearnToTeach" src="../../assets/LearnToTeach.png" alt="">

      <div class="container-2">
      <!-- <img src="../../assets/about_program.png" alt=""> -->
      <div class="register " >
<h2>What you will learn during the <br> course</h2>
<ul >
    <li>An introduction to kids’ yoga</li>
    <li>Do's and Don'ts</li>
    <li>60 poses & 15 types of breathwork </li>
    <li>10 guided meditation scripts</li>
    <li>10 yoga games</li>
    <li>15 partner yoga poses</li>
    <li>5 ready-to-use class plans</li>
    <li>How to teach kids the 5 yamas and 5 niyamas</li>
    <li>An introduction to kids’ yoga</li>
    <li>How to start your own yoga venture for kids'</li>
</ul>
<button  @click="modalbg= !modalbg" >Register Now</button>
      </div>
      </div>
<transition name="modal" mode="out-in">
<Register v-if="modalbg" class="registernow" :modalbg="modalbg" @close="modalbg= !modalbg"    />
</transition>
  </section>


</template>

<script>

import Register from "./Register.vue"

export default {

data(){
    return{
        modalbg:false
    }
},

components:{Register}


}
</script>

<style scoped>
.registernow{
    position: fixed;
    left: 0;
    top: 0;
     width: 100%;
    height: 70%;
     display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    
}
.modal-enter-from{
    opacity: 0;
    transform: scale(0);
}
.modal-enter-to{
    opacity: 1;
    transform: scale(1);
}

.modal-enter-active {
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  
}
.modal-leave-from{
    opacity: 1;
    transform: scale(1);
    /* transform: translateY(400px); */
}
.modal-leave-to{
    opacity: 0;
    transform: scale(0);
}
.modal-leave-active {
  transition: all 0.3s ease;
}

ul{
    list-style-image: url("../../assets/bullet.png");
}
/* .register{
    width: 500px;
height: 540.92px;
background: #60993E;
border-radius: 25px;
display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
} */
.register{
    width: 500px;
    min-height: 540.92px;
background: #60993E;
border-radius: 25px;
display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
}
 .abhyaas{
color: #791E94;
    font-weight: 450;
 }  
h3{
    color: #44526B;
}
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 150px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
button:hover{
    background-color: #ca6500;
}
h2{
    color: white;
}

h1{
    color: #791E94;
    
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
}
li{
    color: white;
    font-weight: 500;
    line-height: 200%;
}
.flex{
    display: flex;
    justify-content: space-evenly;
    align-items: end;
    padding-top: 12rem;
    height: 764px;
    width: 80%;
    margin: auto;
}
.container-1{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    height: 501px;
}
body{
    background: #FFFFF2;
}
.LearnToTeach{
        height: 213px;
}

@media (max-width: 1080px){
    .flex{
flex-wrap: wrap;
height: 1742px;
    }
    .container-1{
height: 687px;
    }
       .register{
         width: auto;
         height: 600px;
    }
      ul{
            width: 247px;

    }
    h2{
        text-align: center;
        padding: 0 30px;
    }
    button{
            padding: 15px 30px;
    }
}

</style>>

